<template>
  <div
    ref="tabsContainer"
    :class="['tce-grid-tabs', { '-overflow': isOverflowing }]"
    role="tablist"
    aria-labelledby="tablist-1"
  >
    <button
      v-for="(tab, index) in tabList"
      :id="`tab-${index + 1}`"
      :key="index"
      role="tab"
      :tabindex="tab.active ? 0 : -1"
      :aria-selected="tab.active"
      aria-controls="panel"
      class="tce-grid-tabs__button"
      @click="selectTab(tab, index)"
    >
      {{ tab.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'tce-grid-tabs',
};
</script>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { debounce } from '../../utilities/timing';
import { AnalyticsHandler } from '../../directives/analyticsHandler';
import Tablist from '../../utilities/tablist';

const TAB_MARGIN = 32;
const MOBILE_SCREEN_END = 767;

/* eslint-disable no-unused-vars */
let tablistInstance;

const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  analytics: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['tab-updated']);

const tabList = ref(props.tabs);
const tabsContainer = ref(null);
const isOverflowing = ref(false);

const isMobile = computed(() => {
  return window.innerWidth < MOBILE_SCREEN_END;
});

function selectTab(tab, index) {
  if (tab.active) return;

  tabList.value.forEach((tabItem, tabIndex) => {
    tabItem.active = tabIndex === index;
  });

  pushAnalytics(tab);

  emit('tab-updated', tab);
}

function pushAnalytics(tab) {
  const tag = {
    type: 'userActionEvent',
    event_name: props.analytics.event_name,
    category: props.analytics.category,
    action: props.analytics.action,
    filter_type: props.analytics.filter_type,
    label: `${props.analytics.filterName}::${tab.name}`,
    filter_value: `${props.analytics.filterName}::${tab.name}`,
  };

  try {
    AnalyticsHandler.getAnalyticsHandler().push(tag);
  } catch (e) {
    /* istanbul ignore next */
    console.warn('Could not push to dataLayer', tag);
  }
}

function checkOverflow() {
  if (tabsContainer.value) {
    const margin = isMobile.value ? TAB_MARGIN : 0;
    const containerWidth = tabsContainer.value.offsetWidth;
    const tabsWidth = Array.from(tabsContainer.value.children).reduce(
      (totalWidth, tab) => totalWidth + tab.offsetWidth + margin,
      0,
    );

    isOverflowing.value = tabsWidth > containerWidth;
  }
}

onMounted(() => {
  window.addEventListener('resize', debounce(checkOverflow, 250));
  checkOverflow();

  const tablists = document.querySelectorAll('.tce-grid-tabs');
  for (let i = 0; i < tablists.length; i++) {
    tablistInstance = new Tablist(tablists[i], true);
  }
});
</script>
